import { SeasonFragment } from '@amf/shared/types/graphql';
import Header from '@amf/shared/components/layout/Header';
import SelectField from '@amf/shared/components/form/SelectField';
import { ChangeEventHandler, useCallback } from 'react';
import { useTranslate } from '@tolgee/react';

interface SeasonHeaderProps {
  title: string;
  seasons: SeasonFragment[];
  selected: SeasonFragment;
  onSeasonChange?: (season) => void;
  className?: string;
}

function SeasonHeader({ title, seasons, selected, onSeasonChange, className }: SeasonHeaderProps) {
  const { t } = useTranslate();
  const changeSeason = useCallback<ChangeEventHandler<HTMLSelectElement>>(
    event => {
      if (!onSeasonChange) return;

      const season = seasons.find(s => s.id === event.target.value);
      if (!season) return;

      if (season.id === selected.id) return;
      onSeasonChange(season);
    },
    [onSeasonChange, seasons, selected.id],
  );

  return (
    <Header title={title} className={className}>
      <SelectField
        label={t('season.label')}
        onChange={changeSeason}
        value={selected.id}
        style={{ minWidth: 140 }}
      >
        {seasons.map(season => (
          <option key={season.id} value={season.id}>
            {season.name}
          </option>
        ))}
      </SelectField>
    </Header>
  );
}

export default SeasonHeader;
